import styled, { css } from 'styled-components'

const Title = styled.p`
  && {
    font-weight: ${props => props.theme.font.weight.bold};
    margin-bottom: 15px;
  }
`

const SubTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  color: ${props => props.theme.color.monochrome.dark};
  flex-wrap: wrap;
  margin-left: -5px; /* Needed to align the stars with the left edge of the container */

  ${props =>
    css`
      @media only screen and (max-width: ${props.theme.size.breakpoint['max-width']['2xs']}) {
        margin-left: 0px;
      }
    `}
`

const RatingMessage = styled.span`
  align-self: flex-start;
  margin-right: 10px;
`

const SecondaryAttributeContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`

const SecondaryAttributeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  width: 120px;
`

const FitText = styled.span`
  font-weight: bold;
`

const AdditionalData = styled.div`
  margin-bottom: 10px;
  margin-right: 10px;
`

const AdditionalDataContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  color: ${props => props.theme.color.monochrome.dark};
`

const UserProfile = styled.p`
  color: ${props => props.theme.color.monochrome.dark};
  margin: 15px 0;
`

const Date = styled.time`
  color: ${props => props.theme.color.monochrome.dark};
`

const ReviewsImage = styled.div`
  display: flex;
  cursor: pointer;
  position: relative;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 3px;
  overflow: hidden;
`

const ReviewsImageIcon = styled.span`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: absolute;
  right: 0;
  background: ${props => props.theme.color.monochrome.white};
  opacity: 0.9;
  border-radius: 3px;
  margin: 5px;
  height: 26px;
  width: 38px;
`

const CrossReview = styled.div`
  color: ${props => props.theme.color.monochrome.dark};
  background-color: ${props => props.theme.color.monochrome.lighter};
  padding: 10px;
  margin-bottom: 15px;
`

const ClientResponseContainer = styled.div`
  color: ${props => props.theme.color.monochrome.dark};
  background-color: ${props => props.theme.color.monochrome.lighter};
  padding: 10px;
  margin-bottom: 15px;
`

const ClientResponseTitle = styled.span`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`

const ResponseTeamText = styled.p`
  font-weight: 600;
`

const ResponseTeamRegards = styled.div`
  margin-top: 10px;
`

export {
  Title,
  SubTitle,
  RatingMessage,
  SecondaryAttributeContainer,
  SecondaryAttributeWrapper,
  FitText,
  UserProfile,
  Date,
  ReviewsImage,
  ReviewsImageIcon,
  CrossReview,
  AdditionalDataContainer,
  AdditionalData,
  ClientResponseContainer,
  ClientResponseTitle,
  ResponseTeamText,
  ResponseTeamRegards
}
